import request from '@/utils/request'
const api = {
  getWallet: 'user_wallet/getWallet',
  payUnlockAll: 'user_wallet/payUnlockAll',
  payUnlockOne: 'user_wallet/payUnlockOne',
  payVip: 'user_wallet/payVip',
  getVipCfg: 'user_wallet/getVipCfg',
  getReceiveList: 'user_wallet/getReceiveList',
  getBankReceiveList: 'user_wallet/getBankReceiveList',
  getWalletLogList: 'user_wallet/getWalletLogList',
  getWalletAddressList: 'user_wallet/getWalletAddressList',
  saveAddress: 'user_wallet/saveAddress',
  getWalletAddressInfo: 'user_wallet/getWalletAddressInfo',
  delWalletAddress: 'user_wallet/delWalletAddress',
  getUserTransferList: 'user_wallet/getUserTransferList',
  withdraw: 'user_wallet/withdraw',
  transfer: 'user_wallet/transferA'
}
export default {
  transfer(parameter) {
    return request({
      url: api.transfer,
      method: 'POST',
      data: parameter
    })
  },
  getWallet(parameter) {
    return request({
      url: api.getWallet,
      method: 'POST',
      data: parameter
    })
  },
  withdraw(parameter) {
    return request({
      url: api.withdraw,
      method: 'POST',
      data: parameter
    })
  },
  getReceiveList(parameter) {
    return request({
      url: api.getReceiveList,
      method: 'POST',
      data: parameter
    })
  },
  getBankReceiveList(parameter) {
    return request({
      url: api.getBankReceiveList,
      method: 'POST',
      data: parameter
    })
  },
  payVip(parameter) {
    return request({
      url: api.payVip,
      method: 'POST',
      data: parameter
    })
  },
  getVipCfg(parameter) {
    return request({
      url: api.getVipCfg,
      method: 'POST',
      data: parameter
    })
  },
  getWalletLogList(parameter) {
    return request({
      url: api.getWalletLogList,
      method: 'POST',
      data: parameter
    })
  },
  getWalletAddressList(parameter) {
    return request({
      url: api.getWalletAddressList,
      method: 'POST',
      data: parameter
    })
  },
  saveAddress(parameter) {
    return request({
      url: api.saveAddress,
      method: 'POST',
      data: parameter
    })
  },
  getWalletAddressInfo(parameter) {
    return request({
      url: api.getWalletAddressInfo,
      method: 'POST',
      data: parameter
    })
  },
  delWalletAddress(parameter) {
    return request({
      url: api.delWalletAddress,
      method: 'POST',
      data: parameter
    })
  },
  getUserTransferList(parameter) {
    return request({
      url: api.getUserTransferList,
      method: 'POST',
      data: parameter
    })
  },
  payUnlockAll(parameter) {
    return request({
      url: api.payUnlockAll,
      method: 'POST',
      data: parameter
    })
  },
  payUnlockOne(parameter) {
    return request({
      url: api.payUnlockOne,
      method: 'POST',
      data: parameter
    })
  }
}
